<template>
  <div>
    <el-divider content-position="left">{{ $t('배달 대행사 설정') }}</el-divider>

    <el-row
      :gutter="0"
      style="margin-bottom: 10px"
      v-if="inputForm.deliveryAgencySettings && inputForm.deliveryAgencySettings.length > 0">
      <el-col :xs="7" :sm="7" :md="4" style="text-align: center">{{ $t('배달 대행사') }}</el-col>
      <el-col :xs="7" :sm="7" :md="4" style="text-align: center">{{ $t('브랜드 코드') }}</el-col>
      <el-col :xs="7" :sm="7" :md="4" style="text-align: center">{{ $t('연동 정보') }}</el-col>
      <el-col :xs="3" :sm="3" :md="2"></el-col>
    </el-row>

    <div v-for="(agencySetting, index) in inputForm.deliveryAgencySettings" :key="`agency-${index}`" class="agency-row">
      <el-row :gutter="0">
        <el-col :xs="7" :sm="7" :md="4" style="text-align: center">
          <el-form-item :error="formError['deliveryAgencySettings.' + index + '.deliveryAgency']" label-width="0">
            <el-select
              v-model="agencySetting.deliveryAgency.agencyType"
              placeholder="배달 대행사 선택"
              @change="onAgencyChange(index)"
              :style="{ width: $device.mobile ? `100%` : `150px` }">
              <el-option
                v-for="item in deliveryAgencyOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="7" :sm="7" :md="4" style="text-align: center">
          <el-form-item
            :error="formError['deliveryAgencySettings.' + index + '.deliveryAgency.brandCode']"
            label-width="0">
            <el-select
              v-model="agencySetting.deliveryAgency.id"
              placeholder="브랜드 코드 선택"
              :style="{ width: $device.mobile ? `100%` : `150px` }">
              <el-option
                v-for="(item, optionIndex) in getBrandCodeOptions(agencySetting.deliveryAgency.agencyType)"
                :key="`brand-${index}-${optionIndex}`"
                :label="item.label"
                :value="item.value.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="7" :sm="7" :md="4" style="text-align: center">
          <el-form-item :error="formError['deliveryAgencySettings.' + index + '.deliveryMid']" label-width="0">
            <el-input
              v-model="agencySetting.deliveryMid"
              placeholder="연동 정보"
              :style="{ width: $device.mobile ? `100%` : `150px` }">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="3" :sm="3" :md="2">
          <el-button
            type="danger"
            icon="el-icon-delete"
            circle
            @click="removeDeliveryAgency(index)"
            size="small"
            style="margin-top: 0px">
          </el-button>
        </el-col>
      </el-row>
    </div>

    <el-row>
      <el-col :md="24">
        <el-button type="primary" icon="el-icon-plus" @click="addDeliveryAgency" size="small" style="margin-top: 10px"
          >{{ $t('배달 대행사 추가') }}
        </el-button>
      </el-col>
    </el-row>

    <el-divider content-position="left">{{ $t('최소 주문 금액') }}</el-divider>

    <el-row :gutter="0" style="margin-bottom: 10px" v-if="inputForm.deliveryFees.length > 0">
      <el-col :xs="10" :sm="10" :md="5" style="text-align: center">{{ $t('주문 금액') }}</el-col>
      <el-col :xs="10" :sm="10" :md="5" style="text-align: center">{{ $t('배달팁') }}</el-col>
      <el-col :xs="4" :sm="4" :md="2"></el-col>
    </el-row>

    <div v-for="(item, index) in inputForm.deliveryFees" :key="`fee-${index}`" class="fee-row">
      <el-row :gutter="0">
        <el-col :xs="10" :sm="10" :md="5" style="text-align: center">
          <el-form-item :error="formError['deliveryFees.' + index + '.minOrderAmount']" label-width="0">
            <el-input-number
              v-model="item.minOrderAmount"
              :min="0"
              :step="1000"
              controls-position="right"
              :style="{ width: $device.mobile ? `` : `150px` }">
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :xs="10" :sm="10" :md="5" style="text-align: center">
          <el-form-item :error="formError['deliveryFees.' + index + '.deliveryFee']" label-width="0">
            <el-input-number
              v-model="item.deliveryFee"
              :min="0"
              :step="500"
              controls-position="right"
              :style="{ width: $device.mobile ? `` : `150px` }">
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :xs="4" :sm="4" :md="2">
          <el-button
            type="danger"
            icon="el-icon-delete"
            circle
            @click="removeDeliveryFee(index)"
            size="small"
            style="margin-top: 0px">
          </el-button>
        </el-col>
      </el-row>
    </div>

    <el-row>
      <el-col :md="24">
        <el-button type="primary" icon="el-icon-plus" @click="addDeliveryFee" size="small" style="margin-top: 10px"
          >{{ $t('주문금액 추가') }}
        </el-button>
      </el-col>
    </el-row>

    <!-- 배달팁 설정 패널 -->
    <el-divider content-position="left">{{ $t('배달팁 설정') }}</el-divider>

    <!-- 사용/미사용 선택 -->
    <div class="clearfix" style="margin-bottom: 24px">
      <div style="float: right">
        <el-button
          :type="!deliveryTipSetting.deliveryTipEnabled ? 'primary' : 'info'"
          size="small"
          @click="setDeliveryTipEnabled(false)"
          :style="{
            backgroundColor: !deliveryTipSetting.deliveryTipEnabled ? '#909399' : '',
            borderColor: !deliveryTipSetting.deliveryTipEnabled ? '#909399' : '',
          }">
          {{ $t('미사용') }}
        </el-button>
        <el-button
          :type="deliveryTipSetting.deliveryTipEnabled ? 'primary' : 'info'"
          size="small"
          @click="setDeliveryTipEnabled(true)"
          :style="{
            backgroundColor: deliveryTipSetting.deliveryTipEnabled ? '#E6A23C' : '',
            borderColor: deliveryTipSetting.deliveryTipEnabled ? '#E6A23C' : '',
            marginLeft: '8px',
          }">
          {{ $t('사용') }}
        </el-button>
      </div>
    </div>

    <div v-if="deliveryTipSetting.deliveryTipEnabled">
      <!-- 거리별/자동 선택 탭 -->
      <div style="margin-bottom: 24px">
        <el-button
          :type="deliveryTipSetting.deliveryTipType === 'distance' ? 'primary' : 'info'"
          @click="setDeliveryTipType('distance')"
          :style="{
            backgroundColor: deliveryTipSetting.deliveryTipType === 'distance' ? '#E6A23C' : '',
            borderColor: deliveryTipSetting.deliveryTipType === 'distance' ? '#E6A23C' : '',
          }">
          {{ $t('거리별') }}
        </el-button>
        <el-button
          :type="deliveryTipSetting.deliveryTipType === 'auto' ? 'primary' : 'info'"
          @click="setDeliveryTipType('auto')"
          :style="{
            backgroundColor: deliveryTipSetting.deliveryTipType === 'auto' ? '#E6A23C' : '',
            borderColor: deliveryTipSetting.deliveryTipType === 'auto' ? '#E6A23C' : '',
            marginLeft: '8px',
          }">
          {{ $t('자동') }}
        </el-button>

        <!-- 배달팁 모드 선택 에러 메시지 -->
        <div
          v-if="formError['deliveryTipSetting.deliveryTipType']"
          style="color: #f56c6c; font-size: 12px; margin-top: 4px">
          {{ formError['deliveryTipSetting.deliveryTipType'] }}
        </div>
      </div>

      <!-- 거리별 선택 시 -->
      <div v-if="deliveryTipSetting.deliveryTipType === 'distance'">
        <!-- 기본배달거리 -->
        <div style="margin-bottom: 16px">
          <label style="font-size: 14px; font-weight: 500; margin-bottom: 8px; display: block">{{
            $t('기본배달거리')
          }}</label>
          <el-select v-model="deliveryTipSetting.basicDeliveryDistance" style="width: 120px">
            <el-option value="미사용" :label="$t('미사용')"></el-option>
            <el-option value="1km" label="1km"></el-option>
            <el-option value="1.5km" label="1.5km"></el-option>
            <el-option value="2km" label="2km"></el-option>
            <el-option value="2.5km" label="2.5km"></el-option>
            <el-option value="3km" label="3km"></el-option>
          </el-select>
        </div>

        <!-- 최대배달거리 -->
        <div style="margin-bottom: 16px">
          <label style="font-size: 14px; font-weight: 500; margin-bottom: 8px; display: block">{{
            $t('최대배달거리')
          }}</label>
          <el-select v-model="deliveryTipSetting.maxDeliveryDistance" style="width: 120px">
            <el-option value="미사용" :label="$t('미사용')"></el-option>
            <el-option
              v-for="distance in maxDeliveryDistanceOptions"
              :key="distance"
              :value="distance"
              :label="distance">
            </el-option>
          </el-select>
        </div>

        <div v-if="deliveryTipSetting.basicDeliveryDistance === '미사용'" style="margin-bottom: 16px">
          <el-alert
            :title="$t('기본배달거리가 미사용으로 설정되어 있습니다. 거리별 추가 배달팁이 적용되지 않습니다.')"
            type="info"
            :closable="false">
          </el-alert>
        </div>

        <div v-if="deliveryTipSetting.basicDeliveryDistance !== '미사용'" style="margin-bottom: 16px">
          <label style="font-size: 14px; font-weight: 500; margin-bottom: 8px; display: block">{{
            $t('추가거리당 할당 배달팁')
          }}</label>
          <div style="display: flex; align-items: center; gap: 8px">
            <el-select v-model="deliveryTipSetting.additionalDistanceUnit" style="width: 120px">
              <el-option value="100m" label="100m당"></el-option>
              <el-option value="500m" label="500m당"></el-option>
            </el-select>
            <el-input-number
              v-model="deliveryTipSetting.additionalDistanceFee"
              :min="100"
              :max="300"
              :step="10"
              controls-position="right"
              style="width: 120px">
            </el-input-number>
            <span>{{ $t('원') }}</span>
          </div>
          <p style="font-size: 12px; color: #909399; margin-top: 4px">
            {{ $t('100원 ~300원까지 입력 가능합니다') }}
          </p>
        </div>

        <!-- 시간별 배달팁 설정 -->
        <div style="margin-bottom: 16px">
          <label style="font-size: 14px; font-weight: 500; margin-bottom: 16px; display: block">{{
            $t('시간별 배달팁 설정')
          }}</label>

          <div v-for="(slot, index) in deliveryTipSetting.timeSlots" :key="index" style="margin-bottom: 16px">
            <el-row :gutter="8">
              <el-col :xs="24" :sm="24" :md="6" :lg="5" style="margin-bottom: 8px">
                <label style="font-size: 12px; color: #606266; margin-bottom: 4px; display: block">{{
                  $t('배달팁')
                }}</label>
                <div style="display: flex; align-items: center; gap: 4px">
                  <el-input-number
                    v-model="slot.deliveryTip"
                    :min="0"
                    :step="100"
                    controls-position="right"
                    :style="{ width: $device.mobile ? '100%' : '120px' }">
                  </el-input-number>
                  <span style="font-size: 14px; color: #606266">{{ $t('원') }}</span>
                </div>
              </el-col>

              <el-col :xs="24" :sm="24" :md="6" :lg="5" style="margin-bottom: 8px">
                <label style="font-size: 12px; color: #606266; margin-bottom: 4px; display: block">{{
                  $t('요일 선택')
                }}</label>
                <el-checkbox-group
                  :value="getSelectedDaysArray(slot.selectedDays)"
                  @input="setSelectedDaysString(index, $event)"
                  style="display: flex; flex-wrap: wrap; gap: 2px">
                  <el-checkbox
                    v-for="day in dayOptions"
                    :key="day.value"
                    :label="day.value"
                    style="margin-right: 4px; margin-bottom: 4px">
                    {{ day.label }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-col>

              <el-col :xs="11" :sm="11" :md="4" :lg="4" style="margin-bottom: 8px">
                <label style="font-size: 12px; color: #606266; margin-bottom: 4px; display: block">{{
                  $t('시작 시간')
                }}</label>
                <el-select v-model="slot.startTime" style="width: 100%">
                  <el-option
                    v-for="hour in 24"
                    :key="hour - 1"
                    :value="String(hour - 1).padStart(2, '0') + ':00'"
                    :label="String(hour - 1).padStart(2, '0') + ':00'">
                  </el-option>
                </el-select>
              </el-col>

              <el-col :xs="11" :sm="11" :md="4" :lg="4" style="margin-bottom: 8px">
                <label style="font-size: 12px; color: #606266; margin-bottom: 4px; display: block">{{
                  $t('종료 시간')
                }}</label>
                <el-select v-model="slot.endTime" style="width: 100%">
                  <el-option
                    v-for="hour in 24"
                    :key="hour - 1"
                    :value="String(hour - 1).padStart(2, '0') + ':00'"
                    :label="String(hour - 1).padStart(2, '0') + ':00'">
                  </el-option>
                </el-select>
              </el-col>

              <el-col :xs="2" :sm="2" :md="4" :lg="6" style="text-align: right; margin-bottom: 8px">
                <el-button
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  size="small"
                  @click="removeTimeSlot(index)"
                  :style="{ marginTop: $device.mobile ? '0' : '20px' }">
                </el-button>
              </el-col>
            </el-row>
          </div>
        </div>

        <!-- 요일시간 추가 버튼 -->
        <el-button type="primary" icon="el-icon-plus" size="small" @click="addTimeSlot">
          {{ $t('요일시간 추가') }}
        </el-button>
      </div>

      <!-- 자동 선택 시 -->
      <div v-if="deliveryTipSetting.deliveryTipType === 'auto'">
        <!-- 거리별단위 -->
        <div style="margin-bottom: 16px">
          <label style="font-size: 14px; font-weight: 500; margin-bottom: 8px; display: block">{{
            $t('기본 배달비')
          }}</label>
          <div style="display: flex; align-items: center; gap: 8px">
            <el-input-number
              v-model="deliveryTipSetting.basicDeliveryFee"
              :min="0"
              :step="100"
              controls-position="right"
              style="width: 150px">
            </el-input-number>
            <span style="font-size: 14px; color: #606266">{{ $t('원') }}</span>
            <span style="font-size: 12px; color: #909399; margin-left: 8px">
              {{ $t('기본 배달비로 추가 거리별 추가요금 배달비 추가') }}
            </span>
          </div>
        </div>

        <!-- 배달비 계산 예시 -->
        <el-alert :title="$t('배달비 계산 예시')" type="info" :closable="false" style="margin-bottom: 16px">
          <div style="font-size: 14px; color: #409eff; margin-top: 8px">
            <p>• {{ $t('배달 대행사 배달비 - 기본 배달비 = 소비자 배달팁 추가') }}</p>
            <p>• {{ $t('배달 대행사 배달비  ( 대행사 기본 배달비 + 우중 할증 + 거리 할증 등 )') }}</p>
          </div>
        </el-alert>

        <!-- 시간별 배달팁 설정 -->
        <div style="margin-bottom: 16px">
          <label style="font-size: 14px; font-weight: 500; margin-bottom: 16px; display: block">{{
            $t('시간별 배달팁 설정')
          }}</label>

          <div v-for="(slot, index) in deliveryTipSetting.timeSlots" :key="index" style="margin-bottom: 16px">
            <el-row :gutter="8">
              <el-col :xs="24" :sm="24" :md="6" :lg="5" style="margin-bottom: 8px">
                <label style="font-size: 12px; color: #606266; margin-bottom: 4px; display: block">{{
                  $t('배달팁')
                }}</label>
                <div style="display: flex; align-items: center; gap: 4px">
                  <el-input-number
                    v-model="slot.deliveryTip"
                    :min="0"
                    :step="100"
                    controls-position="right"
                    :style="{ width: $device.mobile ? '100%' : '120px' }">
                  </el-input-number>
                  <span style="font-size: 14px; color: #606266">{{ $t('원') }}</span>
                </div>
              </el-col>

              <el-col :xs="24" :sm="24" :md="6" :lg="5" style="margin-bottom: 8px">
                <label style="font-size: 12px; color: #606266; margin-bottom: 4px; display: block">{{
                  $t('요일 선택')
                }}</label>
                <el-checkbox-group
                  :value="getSelectedDaysArray(slot.selectedDays)"
                  @input="setSelectedDaysString(index, $event)"
                  style="display: flex; flex-wrap: wrap; gap: 2px">
                  <el-checkbox
                    v-for="day in dayOptions"
                    :key="day.value"
                    :label="day.value"
                    style="margin-right: 4px; margin-bottom: 4px">
                    {{ day.label }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-col>

              <el-col :xs="11" :sm="11" :md="4" :lg="4" style="margin-bottom: 8px">
                <label style="font-size: 12px; color: #606266; margin-bottom: 4px; display: block">{{
                  $t('시작 시간')
                }}</label>
                <el-select v-model="slot.startTime" style="width: 100%">
                  <el-option
                    v-for="hour in 24"
                    :key="hour - 1"
                    :value="String(hour - 1).padStart(2, '0') + ':00'"
                    :label="String(hour - 1).padStart(2, '0') + ':00'">
                  </el-option>
                </el-select>
              </el-col>

              <el-col :xs="11" :sm="11" :md="4" :lg="4" style="margin-bottom: 8px">
                <label style="font-size: 12px; color: #606266; margin-bottom: 4px; display: block">{{
                  $t('종료 시간')
                }}</label>
                <el-select v-model="slot.endTime" style="width: 100%">
                  <el-option
                    v-for="hour in 24"
                    :key="hour - 1"
                    :value="String(hour - 1).padStart(2, '0') + ':00'"
                    :label="String(hour - 1).padStart(2, '0') + ':00'">
                  </el-option>
                </el-select>
              </el-col>

              <el-col :xs="2" :sm="2" :md="4" :lg="6" style="text-align: right; margin-bottom: 8px">
                <el-button
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  size="small"
                  @click="removeTimeSlot(index)"
                  :style="{ marginTop: $device.mobile ? '0' : '20px' }">
                </el-button>
              </el-col>
            </el-row>
          </div>
        </div>

        <!-- 요일시간 추가 버튼 -->
        <el-button type="primary" icon="el-icon-plus" size="small" @click="addTimeSlot">
          {{ $t('요일시간 추가') }}
        </el-button>
      </div>
    </div>

    <div v-if="!deliveryTipSetting.deliveryTipEnabled" style="padding: 32px 0; text-align: center">
      <div style="color: #909399">
        <p>{{ $t('배달팁 추가 기능이 비활성화되어 있습니다.') }}</p>
        <p style="font-size: 14px; margin-top: 4px">{{ $t('사용하려면 위의 사용 버튼을 클릭하세요.') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['value', 'formError', 'deliveryAgencyOptions', 'brandCodeOptionsMap'],

  data() {
    return {
      dayOptions: [
        { label: '월', value: '월' },
        { label: '화', value: '화' },
        { label: '수', value: '수' },
        { label: '목', value: '목' },
        { label: '금', value: '금' },
        { label: '토', value: '토' },
        { label: '일', value: '일' },
      ],
    }
  },

  computed: {
    inputForm: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('update', value)
      },
    },
    // 배달팁 설정 관련 computed 속성들
    deliveryTipSetting() {
      return (
        this.inputForm.deliveryTipSetting || {
          deliveryTipEnabled: false,
          deliveryTipType: 'distance',
          basicDeliveryDistance: '미사용',
          maxDeliveryDistance: '미사용',
          additionalDistanceUnit: '100m',
          additionalDistanceFee: 100,
          basicDeliveryFee: 4200,
          timeSlots: [],
        }
      )
    },
    // 최대배달거리 옵션 생성 (1km부터 0.5km 단위로 30km까지)
    maxDeliveryDistanceOptions() {
      const options = []
      for (let i = 1; i <= 30; i += 0.5) {
        options.push(`${i}km`)
      }
      return options
    },
  },
  methods: {
    addDeliveryFee(...rest) {
      const newFee = {
        id: Date.now(),
        ...rest[0],
      }
      this.$emit('addDeliveryFee', newFee)
    },
    removeDeliveryFee(...rest) {
      this.$emit('removeDeliveryFee', ...rest)
    },
    addDeliveryAgency() {
      this.$emit('addDeliveryAgency', {
        useYn: 'Y',
        deliveryAgencySettingCd: null,
        deliveryAgency: {
          useYn: 'Y',
          id: null,
          companyCode: '',
          companyName: '',
          brandCode: '',
          brandName: '',
          agencyType: '',
          description: null,
        },
        deliveryMid: '',
      })
    },
    removeDeliveryAgency(index) {
      this.$emit('removeDeliveryAgency', index)

      // 배달 대행사 삭제 후 남은 대행사가 없으면 자동 모드를 거리별 모드로 변경
      this.$nextTick(() => {
        const hasDeliveryAgency =
          this.inputForm.deliveryAgencySettings &&
          this.inputForm.deliveryAgencySettings.length > 0 &&
          this.inputForm.deliveryAgencySettings.some((agency) => agency.deliveryAgency && agency.deliveryAgency.id)

        if (
          !hasDeliveryAgency &&
          this.inputForm.deliveryTipSetting &&
          this.inputForm.deliveryTipSetting.deliveryTipType === 'auto'
        ) {
          this.$set(this.inputForm.deliveryTipSetting, 'deliveryTipType', 'distance')
          this.$message({
            type: 'info',
            message: '배달 대행사가 없어 배달팁 모드를 거리별로 변경했습니다.',
          })
        }
      })
    },
    getBrandCodeOptions(agencyType) {
      if (!agencyType) return []
      return this.brandCodeOptionsMap[agencyType] || []
    },
    onAgencyChange(index) {
      // 배달 대행사가 변경되면 브랜드 코드 초기화
      if (this.inputForm.deliveryAgencySettings && this.inputForm.deliveryAgencySettings[index]) {
        this.inputForm.deliveryAgencySettings[index].deliveryAgency.brandCode = ''
      }
    },

    // 배달팁 관련 메서드들
    setDeliveryTipEnabled(enabled) {
      // deliveryTipSetting이 없으면 초기화
      if (!this.inputForm.deliveryTipSetting) {
        this.$set(this.inputForm, 'deliveryTipSetting', {
          deliveryTipEnabled: enabled,
          deliveryTipType: 'distance',
          basicDeliveryDistance: '미사용',
          maxDeliveryDistance: '미사용',
          additionalDistanceUnit: '100m',
          additionalDistanceFee: 100,
          basicDeliveryFee: 4200,
          timeSlots: [],
        })
      } else {
        this.$set(this.inputForm.deliveryTipSetting, 'deliveryTipEnabled', enabled)
      }
    },

    setDeliveryTipType(type) {
      if (this.inputForm.deliveryTipSetting) {
        // 자동 모드 선택 시 배달 대행사 설정 확인
        if (type === 'auto') {
          const hasDeliveryAgency =
            this.inputForm.deliveryAgencySettings &&
            this.inputForm.deliveryAgencySettings.length > 0 &&
            this.inputForm.deliveryAgencySettings.some((agency) => agency.deliveryAgency && agency.deliveryAgency.id)

          if (!hasDeliveryAgency) {
            this.$message({
              type: 'warning',
              message: '배달팁 자동 모드를 사용하려면 먼저 배달 대행사를 설정해주세요.',
            })
            return
          }
        }

        this.$set(this.inputForm.deliveryTipSetting, 'deliveryTipType', type)
      }
    },

    addTimeSlot() {
      // deliveryTipSetting이 없으면 먼저 초기화
      if (!this.inputForm.deliveryTipSetting) {
        this.setDeliveryTipEnabled(true)
      }

      // timeSlots 배열이 없으면 초기화
      if (!this.inputForm.deliveryTipSetting.timeSlots) {
        this.$set(this.inputForm.deliveryTipSetting, 'timeSlots', [])
      }

      const newTimeSlot = {
        deliveryTip: 0,
        selectedDays: '',
        startTime: '00:00',
        endTime: '00:00',
        ord: this.inputForm.deliveryTipSetting.timeSlots.length,
      }
      this.inputForm.deliveryTipSetting.timeSlots.push(newTimeSlot)
    },

    removeTimeSlot(slotIndex) {
      if (this.inputForm.deliveryTipSetting && this.inputForm.deliveryTipSetting.timeSlots) {
        this.inputForm.deliveryTipSetting.timeSlots.splice(slotIndex, 1)
        // 순서 재정렬
        this.inputForm.deliveryTipSetting.timeSlots.forEach((slot, index) => {
          slot.ord = index
        })
      }
    },

    // selectedDays 배열과 문자열 변환 헬퍼 메서드들
    getSelectedDaysArray(selectedDaysString) {
      if (!selectedDaysString) return []
      return selectedDaysString.split(',').filter((day) => day.trim())
    },

    setSelectedDaysString(slotIndex, selectedDaysArray) {
      if (
        this.inputForm.deliveryTipSetting &&
        this.inputForm.deliveryTipSetting.timeSlots &&
        this.inputForm.deliveryTipSetting.timeSlots[slotIndex]
      ) {
        const selectedDaysString = selectedDaysArray.join(',')
        this.$set(this.inputForm.deliveryTipSetting.timeSlots[slotIndex], 'selectedDays', selectedDaysString)
      }
    },
  },
}
</script>

<style scoped>
.agency-row {
  margin-bottom: 10px;
}
.fee-row {
  margin-bottom: 10px;
}
</style>
